import { hasThirdPartyRegistrationPayload } from '../utils/third-party-login'

export default defineNuxtPlugin({
  name: 'third-party-registration',
  dependsOn: ['shared-app-store'],
  setup(nuxtApp) {
    // OAuth 回跳到原页面后，延迟由登录弹窗消费 sessionStorage 中的一次性身份。
    if (hasThirdPartyRegistrationPayload()) {
      useAppStore(nuxtApp.$pinia).setLoginShow(true)
    }
  },
})
